var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3906 19.9248L13.7232 13.7901C14.7981 12.3536 15.4452 10.5274 15.4452 8.53905C15.4452 3.92972 11.9808 0.179688 7.72257 0.179688C3.46435 0.179688 0 3.92972 0 8.53905C0 13.1484 3.46438 16.8984 7.72261 16.8984C9.55949 16.8984 11.2466 16.198 12.5737 15.0344L18.2411 21.1691C18.3999 21.3409 18.6572 21.3409 18.816 21.1691L19.3906 20.547C19.5493 20.3752 19.5493 20.0966 19.3906 19.9248ZM7.72261 15.1385C4.36065 15.1385 1.62582 12.1782 1.62582 8.53905C1.62582 4.89988 4.36065 1.93956 7.72261 1.93956C11.0846 1.93956 13.8194 4.89988 13.8194 8.53905C13.8194 12.1782 11.0846 15.1385 7.72261 15.1385Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d386b2272d436bf74be70fd6b2b98382.svg";
export { ForwardRef as ReactComponent };